/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_EarlierInputs */

const en_landing_calendar_earlier = /** @type {(inputs: Landing_Calendar_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier days`)
};

const pl_landing_calendar_earlier = /** @type {(inputs: Landing_Calendar_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wcześniejsze dni`)
};

/**
* | output |
* | --- |
* | "Earlier days" |
*
* @param {Landing_Calendar_EarlierInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_earlier = /** @type {((inputs?: Landing_Calendar_EarlierInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_EarlierInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_earlier(inputs)
	return en_landing_calendar_earlier(inputs)
});